// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller
/* eslint-disable */

import { application } from "../application"
import "../shared"

import CalendarController from './calendar_controller.js'
application.register('calendar', CalendarController)

import CarouselController from './carousel_controller.js'
application.register('carousel', CarouselController)

import DynaformController from './dynaform_controller.js'
application.register('dynaform', DynaformController)

import FormController from './form_controller.js'
application.register('form', FormController)

import InvitationTemplatesController from './invitation_templates_controller.js'
application.register('invitation-templates', InvitationTemplatesController)

import ModalController from './modal_controller.js'
application.register('modal', ModalController)

import NavigationController from './navigation_controller.js'
application.register('navigation', NavigationController)

import TimeController from './time_controller.js'
application.register('time', TimeController)
